import React from 'react';
import {AccountScoreCustomizeItem, useAccountScoreSettingQuery} from 'api';
import Item from './Item';
import {CustomizeItemContext} from './CustomizeItemContext';

const List = () => {
  const {data: {accountScoreSetting = {}} = {}} = useAccountScoreSettingQuery(
    {},
  );
  const items =
    accountScoreSetting?.clientAccountScoreSettingCustomizeItems ?? [];


  return (
    <>
      {items?.map((item: AccountScoreCustomizeItem) => {
        return (
          <CustomizeItemContext.Provider value={item}>
            <Item key={item.id} />
          </CustomizeItemContext.Provider>
        );
      })}
    </>
  );
};

export default List;
